module.exports = __webpack_public_path__ + "static/media/mouthRollUpper.ebba350d.obj";